import styled from 'styled-components';
import { Checkbox } from 'antd';

export const CheckboxListItem = styled(Checkbox)`
  width: 100%;
  height: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;

  &:after {
    display: none;
  }

  .ant-checkbox + span {
    padding-left: 0px;
    padding-right: 0;
  }
`;
